import { create } from 'zustand';
import {
  ProductStatusClient,
  ProductStatus,
  StockStageTransition,
} from '../clients/ProductStatusClient';

interface ProductStagesState {
  stages: ProductStatus[];
  loading: boolean;
  error: string | null;
  getStages: (organizationId: string) => Promise<void>;
  createStage: (
    stage: Omit<ProductStatus, 'id' | 'created_at' | 'updated_at'>,
    organizationId: string
  ) => Promise<void>;
  updateStage: (
    stage: Omit<ProductStatus, 'created_at' | 'updated_at'>
  ) => Promise<void>;
  deleteStage: (stageId: string) => Promise<void>;
  getProductStageHistory: (productId: string) => Promise<StockStageTransition[]>;
  transitionProductStage: (
    productId: string,
    toStageId: string,
    notes?: string
  ) => Promise<void>;
  //   getStageMetrics: (
  //     organizationId: string,
  //     timeRange?: 'day' | 'week' | 'month'
  //   ) => Promise<any>;
}

export const useProductStagesStore = create<ProductStagesState>((set, get) => ({
  stages: [],
  loading: false,
  error: null,

  getStages: async (organizationId: string) => {
    set({ loading: true, error: null });
    try {
      const stages = await ProductStatusClient.getStatusesByOrganizationId(
        organizationId
      );
      set({ stages, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  },

  createStage: async (stage, organizationId) => {
    set({ loading: true, error: null });
    try {
      await ProductStatusClient.createStage({
        ...stage,
        organization_id: organizationId,
      });

      await get().getStages(organizationId);
    } catch (error) {
      console.error(error);
      set({ error: (error as Error).message, loading: false });
      throw error;
    }
  },

  updateStage: async (stage) => {
    set({ loading: true, error: null });
    try {
      const updatedStage = await ProductStatusClient.updateStage(stage);
      set((state) => ({
        stages: state.stages.map((s) => (s.id === stage.id ? updatedStage : s)),
        loading: false,
      }));
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  },

  deleteStage: async (stageId) => {
    set({ loading: true, error: null });
    try {
      await ProductStatusClient.deleteStage(stageId);
      set((state) => ({
        stages: state.stages.filter((s) => s.id !== stageId),
        loading: false,
      }));
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  },

  getProductStageHistory: async (productId) => {
    set({ loading: true, error: null });
    try {
      const history = await ProductStatusClient.getProductStatusHistory(
        productId
      );
      set({ loading: false });
      return history;
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
      return [];
    }
  },

  transitionProductStage: async (stockId, toStageId, notes) => {
    set({ loading: true, error: null });
    try {
      await ProductStatusClient.transitionStockStage(stockId, toStageId, notes);
      set({ loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  },

  //   getStageMetrics: async (organizationId: string, timeRange = 'month') => {
  //     set({ loading: true, error: null });
  //     try {
  //       const metrics = await ProductStatusClient.getStageMetrics(
  //         organizationId,
  //         timeRange
  //       );
  //       set({ loading: false });
  //       return metrics;
  //     } catch (error) {
  //       set({ error: (error as Error).message, loading: false });
  //       return null;
  //     }
  //   },
}));
